/* eslint-disable react/jsx-props-no-spreading */
import { UserPermissions } from '@centecomm/portal-service';
import { useCurrentUser } from '@centecomm/portal-service-react';
import React from 'react';

/*
 * Takes permission(s)
 * If pass, render children
 * If fail with FallbackComponent, render FallbackComponent
 * If fail, render null
 */

type ProtectedContext = 'any' | 'site' | 'property' | 'occupant';

interface ProtectedComponentProps {
    children: React.ReactNode;
    permissions: UserPermissions[];
    FallbackComponent?: () => JSX.Element;
    context?: ProtectedContext;
    occupantId?: number;
    propertyId?: number;
}

function ProtectedComponent({
    children,
    permissions,
    context = 'any',
    FallbackComponent,
    occupantId,
    propertyId,
}: ProtectedComponentProps): JSX.Element | null {
    const { hasPermission, hasSitePermission, hasPropertyPermission, hasOccupantPermission } = useCurrentUser();

    const validation = (): boolean =>
        ({
            any: permissions.some((permission) => hasPermission(permission)),
            site: permissions.some((permission) => hasSitePermission(permission)),
            property: permissions.some((permission) => !!propertyId && hasPropertyPermission(permission, propertyId)),
            occupant: permissions.some(
                (permission) => !!propertyId && !!occupantId && hasOccupantPermission(permission, propertyId, occupantId),
            ),
        }[context]);

    if (validation()) return <>{children}</>;

    if (FallbackComponent) return <FallbackComponent />;

    return null;
}

export default ProtectedComponent;
